import React from 'react';
import { Table, Tag, Typography } from 'antd';
import { billing } from '../../mockData';
import './Clients.css';

function BillingClients() {
  const { Title } = Typography;

  const columns = [
    { title: 'Client', dataIndex: 'name', key: 'name' },
    { title: 'Plan', dataIndex: 'currentPlan', key: 'currentPlan' },
    { title: 'Balance Due', dataIndex: 'balanceDue', key: 'balanceDue', align: 'right', render: (v) => (
      <Tag color={v > 0 ? 'red' : 'green'}>{v > 0 ? `$${v.toFixed(2)}` : 'PAID'}</Tag>
    ) },
  ];

  return (
    <div className="agency-billing-clients">
      <Title level={3}>Client Billing</Title>
      <Table rowKey={(r) => r.clientId} columns={columns} dataSource={billing.clients} pagination={{ pageSize: 5 }} />
    </div>
  );
}

export default BillingClients;
